/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import {
  Controller,
  useFieldArray,
  useFormContext,
  useWatch,
} from 'react-hook-form';
import { Input, Typography } from 'antdV4';
import { Row, Col, Select, Button, Checkbox } from 'antd';
import { ErrorMessage } from '@hookform/error-message';
import ImageUpload from '../../../fit-studio/components/upload/ImageUpload';
import {
  answerDefaultValues,
  ELegacySurveyQuestionAnswerType,
  ELegacySurveyQuestionCondition,
  ELegacySurveyQuestionType,
} from '../dto/legacy-survey-form.dto';
import AnswerCard from './AnswerCard';
import fitSurvey2Services from '../../../../../services/fit-survey2.services';

const LegacySurveyQuestionForm = () => {
  const {
    watch,
    reset,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const { data } = fitSurvey2Services.useQueryGetLegacySurveyQuestionById(
    { questionId: watch('id') },
    (data) => {
      reset({
        ...data,
        formType: 'edit',
      });
    },
  );

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'answers',
  });

  const isAnswered = !!useWatch({ control, name: 'isAnswered' });

  return (
    <div>
      <Controller
        name="imageUrl"
        control={control}
        render={({ field: { value, onChange } }) => {
          return (
            <Row className="align-items-center mb-2">
              <Col span={24}>
                <ImageUpload
                  value={value}
                  onChange={onChange}
                  width={200}
                  height={200}
                  errors={errors}
                  notRequired
                  disabled={isAnswered}
                />
              </Col>
            </Row>
          );
        }}
      />
      <Controller
        name="question"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>
                  คำถาม <span style={{ color: 'red' }}>*</span>
                </Typography.Text>
              </Col>
              <Col span={20}>
                <Input.TextArea
                  value={value}
                  onChange={onChange}
                  rows={2}
                  placeholder="คำถาม"
                  disabled={isAnswered}
                />
              </Col>
              <ErrorMessage
                errors={errors}
                name="question"
                render={({ message }) => (
                  <Typography.Text className="mb-2 text-danger">
                    {message}
                  </Typography.Text>
                )}
              />
            </Row>
          );
        }}
      />
      <Controller
        name="type"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>
                  รูปแบบคำตอบ <span style={{ color: 'red' }}>*</span>
                </Typography.Text>
              </Col>
              <Col span={20}>
                <Select
                  value={value}
                  style={{ width: '100%' }}
                  disabled={isAnswered}
                  onChange={(value) => {
                    if (value === 'text') {
                      setValue('answers', [
                        {
                          imageUrl: '',
                          answer: '',
                          isOther: false,
                          isComment: false,
                          weight: 0,
                        },
                      ]);
                    } else {
                      if (data && data.answers) {
                        setValue('answers', data.answers);
                      } else {
                        setValue('answers', answerDefaultValues);
                      }
                    }
                    onChange(value);
                  }}
                >
                  {ELegacySurveyQuestionType.map((item) => {
                    return (
                      <Select.Option key={item.value} value={item.value}>
                        {item.label}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Col>
            </Row>
          );
        }}
      />
      {['select'].includes(watch('type')) && (
        <Controller
          name="answerType"
          control={control}
          render={({ field: { onChange, value } }) => {
            return (
              <Row className="align-items-center  mb-2">
                <Col span={4}>
                  <Typography.Text>
                    ประเภทคำตอบ <span style={{ color: 'red' }}>*</span>
                  </Typography.Text>
                </Col>
                <Col span={20}>
                  <Select
                    value={value}
                    style={{ width: '100%' }}
                    disabled={isAnswered}
                    onChange={(value) => {
                      onChange(value);
                    }}
                  >
                    {ELegacySurveyQuestionAnswerType.map((item) => {
                      return (
                        <Select.Option key={item.value} value={item.value}>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
              </Row>
            );
          }}
        />
      )}
      {['select', 'multi_select'].includes(watch('type')) &&
        fields
          .sort((a, b) => {
            return a.index - b.index;
          })
          .map((item, index) => {
            return (
              <AnswerCard
                key={item.id}
                item={item}
                index={index}
                remove={remove}
                disabled={isAnswered}
              />
            );
          })}
      {['select', 'multi_select'].includes(watch('type')) &&
        !isAnswered && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={() => {
                append({
                  answer: '',
                  imageUrl: '',
                });
              }}
            >
              เพิ่มคำตอบ
            </Button>
          </div>
        )}
      {['select', 'multi_select'].includes(watch('type')) && (
        <div style={{ display: 'flex' }}>
          <div
            style={{ cursor: 'pointer', marginRight: 10 }}
            onClick={() => {
              setValue('isHasOther', !watch('isHasOther'));
            }}
          >
            <Checkbox
              checked={watch('isHasOther')}
              onChange={(value) => {
                setValue('isHasOther', value.target.checked);
              }}
              style={{ marginRight: 5 }}
              disabled={isAnswered}
            />
            <Typography.Text>อื่นๆ โปรดระบุ</Typography.Text>
          </div>
        </div>
      )}
      {['multi_select'].includes(watch('type')) && (
        <Controller
          name="condition"
          control={control}
          render={({ field: { onChange, value } }) => {
            return (
              <Row className="align-items-center  mb-2">
                <Col span={8}>
                  <Typography.Text>
                    กำหนดรูปแบบของคำตอบ <span style={{ color: 'red' }}>*</span>
                  </Typography.Text>
                </Col>
                <Col span={8}>
                  <Select
                    value={value}
                    style={{ width: '100%' }}
                    disabled={isAnswered}
                    onChange={(value) => {
                      onChange(value);
                    }}
                  >
                    {ELegacySurveyQuestionCondition.map((item) => {
                      return (
                        <Select.Option key={item.value} value={item.value}>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
                {!['not_fixed'].includes(watch('condition')) && (
                  <Controller
                    name="conditionNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      return (
                        <Col span={4}>
                          <Input
                            value={value}
                            onChange={onChange}
                            placeholder="คำถาม"
                            className="ml-2"
                            disabled={isAnswered}
                          />
                        </Col>
                      );
                    }}
                  />
                )}
              </Row>
            );
          }}
        />
      )}
      {/* {['multi_select'].includes(watch('type')) && (
        <div style={{ display: 'flex' }}>
          <div
            style={{ cursor: 'pointer', marginRight: 10 }}
            onClick={() => {
              setValue('isNoAnswer', !watch('isNoAnswer'));
            }}
          >
            <Checkbox
              checked={watch('isNoAnswer')}
              onChange={(value) => {
                setValue('isNoAnswer', value.target.checked);
              }}
              style={{ marginRight: 5 }}
            />
            <Typography.Text>แสดงตัวเลือก "ไม่มีคำตอบข้างบน"</Typography.Text>
          </div>
        </div>
      )} */}
      {['select', 'multi_select'].includes(watch('type')) && (
        <div>
          <div style={{ display: 'flex' }}>
            <div
              style={{ cursor: 'pointer', marginRight: 10 }}
              onClick={() => {
                setValue('isUserAnswerText', !watch('isUserAnswerText'));
                if (!watch('isUserAnswerText')) {
                  setValue('required', false);
                }
              }}
            >
              <Checkbox
                checked={watch('isUserAnswerText')}
                onChange={(value) => {
                  setValue('isUserAnswerText', value.target.checked);
                  if (!value.target.checked) {
                    setValue('required', false);
                  }
                }}
                style={{ marginRight: 5 }}
                disabled={isAnswered}
              />
              <Typography.Text>มีช่องแสดงความคิดเห็น</Typography.Text>
            </div>
          </div>
          {watch('isUserAnswerText') && (
            <div style={{ display: 'flex' }}>
              <div
                style={{ cursor: 'pointer', marginRight: 10 }}
                onClick={() => {
                  setValue('required', !watch('required'));
                }}
              >
                <Checkbox
                  checked={watch('required')}
                  onChange={(value) => {
                    setValue('required', value.target.checked);
                  }}
                  style={{ marginRight: 5 }}
                  disabled={isAnswered}
                />
                <Typography.Text>ต้องแสดงความคิดเห็นนี้</Typography.Text>
              </div>
            </div>
          )}
        </div>
      )}
      {watch('type') === 'text' && (
        <Row className="align-items-center  mb-2">
          <Col span={4} />
          <Col span={20}>
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  cursor: isAnswered ? 'not-allowed' : 'pointer',
                  marginRight: 10,
                }}
                onClick={() => {
                  if (isAnswered) return;
                  setValue('required', true);
                }}
              >
                <Checkbox
                  checked={watch('required')}
                  onChange={(value) => {
                    setValue('required', true);
                  }}
                  style={{ marginRight: 5 }}
                  disabled={isAnswered}
                />
                <Typography.Text>บังคับตอบ</Typography.Text>
              </div>
              <div
                style={{
                  cursor: isAnswered ? 'not-allowed' : 'pointer',
                }}
                onClick={() => {
                  if (isAnswered) return;
                  setValue('required', false);
                }}
              >
                <Checkbox
                  checked={!watch('required')}
                  onChange={(value) => {
                    setValue('required', false);
                  }}
                  style={{ marginRight: 5 }}
                  disabled={isAnswered}
                />
                <Typography.Text>ไม่บังคับตอบ</Typography.Text>
              </div>
            </div>
          </Col>
        </Row>
      )}
      {isAnswered && (
        <Row className="align-items-center mb-2">
          <Col span={24}>
            <Typography.Text type="warning">
              คำถามนี้มีผู้ตอบแบบสอบถามไปแล้ว ไม่สามารถแก้ไข เพิ่ม
              หรือลดคำตอบได้ กรุณาติดต่อเจ้าหน้าที่
            </Typography.Text>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default LegacySurveyQuestionForm;
